<template>
  <el-dialog
    append-to-body
    width="800px"
    title="查看退款"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
  >
    <div class="content" v-if="info">
      <el-descriptions
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="订单信息"
        :column="1"
        border
        style="margin-bottom: 10px"
      >
        <template v-if="info.type == 2">
          <el-descriptions-item label="名称">{{
            info.company_name
          }}</el-descriptions-item>
          <el-descriptions-item label="账号">{{
            info.account
          }}</el-descriptions-item>
          <el-descriptions-item label="充值端口"> 企业端 </el-descriptions-item>
          <el-descriptions-item label="订单类型">{{
            toStr({ 1: "人才币", 2: "保证金", 3: "诚信保" }, info.type)
          }}</el-descriptions-item>
          <el-descriptions-item label="总支付金额"
            >{{ info.amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="扣款金额" v-if="info.type != 3"
            >{{ info.amount - info.refund_amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="退款原因" v-if="info.type == 3">{{
            info.work_status == 1 ? "入职满10天" : "已离职"
          }}</el-descriptions-item>
        </template>
        <template v-if="info.type == 3">
          <el-descriptions-item label="名称">{{
            info.nickname
          }}</el-descriptions-item>
          <el-descriptions-item label="账号">{{
            info.account
          }}</el-descriptions-item>
          <el-descriptions-item label="充值端口"> 求职端 </el-descriptions-item>
          <el-descriptions-item label="订单类型">{{
            toStr({ 1: "人才币", 2: "保证金", 3: "诚信保" }, info.type)
          }}</el-descriptions-item>
          <el-descriptions-item label="支付金额"
            >{{ info.amount }}元</el-descriptions-item
          >
          <el-descriptions-item label="支付渠道">{{
            toStr({ 1: "微信", 2: "支付宝" }, info.pay_type)
          }}</el-descriptions-item>
          <el-descriptions-item label="交易流水号">{{
            info.order_no
          }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{
            info.pay_time
          }}</el-descriptions-item>
        </template>
      </el-descriptions>
      <!-- 企业端 -->
      <el-descriptions
        v-if="info.type == 2"
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="退款信息"
        :column="1"
        border
      >
        <el-descriptions-item label="申请时间">
          {{ info.apply_time }}
        </el-descriptions-item>
        <el-descriptions-item label="退款原因">{{
          info.refund_reason
        }}</el-descriptions-item>
        <el-descriptions-item label="补充描述">{{
          info.apply_desc
        }}</el-descriptions-item>
        <el-descriptions-item label="收款名称">{{
          info.company_name
        }}</el-descriptions-item>
        <el-descriptions-item label="银行账户">{{
          info.bank_code
        }}</el-descriptions-item>
        <el-descriptions-item label="开户银行">{{
          info.bank_name
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额"
          >{{ info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label-class-name="my-label" label="处理时间">
          {{ info.check_time }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" label="处理结果">
          {{
            toStr(
              { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
              info.is_refund
            )
          }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="my-label"
          label="拒绝原因"
          v-if="info.refuse_desc"
        >
          {{ info.refuse_desc }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" label="打款凭证">
          <el-dropdown
            trigger="click"
            placement="bottom"
            @command="handleCommand($event, info)"
          >
            <span style="cursor: pointer; color: #409eff">
              {{ info.refund_img.length }}张
            </span>
            <el-dropdown-menu
              slot="dropdown"
              v-if="info.refund_img && info.refund_img.length"
            >
              <el-dropdown-item
                v-for="(item, index) in info.refund_img"
                :command="index"
                :key="index"
                >凭证{{ index + 1 }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-descriptions-item>
      </el-descriptions>
      <!-- 求职端  -->
      <!-- 求职端  找到工作全额退-->
      <el-descriptions
        v-if="info.type == 3 && info.company_name"
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="退款信息"
        :column="1"
        border
      >
        <el-descriptions-item label="申请时间">
          {{ info.apply_time }}
        </el-descriptions-item>
        <el-descriptions-item label="入职企业">{{
          info.company_name
        }}</el-descriptions-item>
        <el-descriptions-item label="入职日期">{{
          info.entry_date
        }}</el-descriptions-item>
        <el-descriptions-item label="扣款金额" v-if="info.type != 3"
          >{{ info.amount - info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label="退款原因" v-if="info.type == 3">{{
          info.work_status == 1 ? "入职满10天" : "已离职"
        }}</el-descriptions-item>
        <el-descriptions-item label="退款金额"
          >{{ info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item
          :label="info.work_status == 1 ? '入职凭证' : '离职凭证'"
        >
          <el-image
            v-for="(item, index) in info.refund_img"
            :key="index"
            style="width: 100px; height: 100px"
            :src="item"
            :preview-src-list="info.refund_img"
          >
          </el-image>
          <!-- <el-dropdown
            trigger="click"
            placement="bottom"
            @command="handleCommand($event, info)"
          >
            <span style="cursor: pointer; color: #409eff">
              {{ info.refund_img.length }}张
            </span>
            <el-dropdown-menu
              slot="dropdown"
              v-if="info.refund_img && info.refund_img.length"
            >
              <el-dropdown-item
                v-for="(item, index) in info.refund_img"
                :command="index"
                :key="index"
                >凭证{{ index + 1 }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown> -->
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" label="处理结果">
          {{
            toStr(
              { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
              info.is_refund
            )
          }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" label="处理时间">
          {{ info.check_time }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="my-label"
          label="拒绝原因"
          v-if="info.refuse_desc"
        >
          {{ info.refuse_desc }}
        </el-descriptions-item>
      </el-descriptions>
      <!-- 求职端  没找到工作按天扣费，退还剩余部分-->
      <el-descriptions
        v-if="info.type == 3 && !info.company_name"
        :labelStyle="label_style"
        :contentStyle="content_style"
        title="退款信息"
        :column="1"
        border
      >
        <el-descriptions-item label="申请时间">
          {{ info.apply_time }}
        </el-descriptions-item>
        <el-descriptions-item label="使用天数"
          >{{ info.days }}天</el-descriptions-item
        >
        <el-descriptions-item label="扣款金额"
          >{{ info.amount - info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label="退款金额"
          >{{ info.refund_amount }}元</el-descriptions-item
        >
        <el-descriptions-item label="退款原因">{{
          info.refund_reason
        }}</el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" label="处理结果">
          {{
            toStr(
              { 0: "未退款", 1: "申请中", 2: "已退款", 3: "已拒绝" },
              info.is_refund
            )
          }}
        </el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" label="处理时间">
          {{ info.check_time }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="my-label"
          label="拒绝原因"
          v-if="info.refuse_desc"
        >
          {{ info.refuse_desc }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
import { checkAmount_ } from "@/util/validator.js";
export default {
  name: "handleRefundDialog",
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      visible2: false,
      loading: false,
      label_style: {
        width: "20%",
      },
      content_style: {
        width: "80%",
      },
      info: null,
    };
  },
  methods: {
    getDetail(row) {
      this.info = row;
      console.log(this.info, "info");
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    toStr(data, key) {
      return data[key] || "";
    },
    handleCommand(e, row) {
      window.open(row.refund_img[e]);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  overflow: auto;
}
::v-deep {
  .my-label {
    color: red !important;
  }
}
</style>
